import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=4bf144ec&scoped=true&"
import script from "./AlertBanner.vue?vue&type=script&setup=true&lang=js&"
export * from "./AlertBanner.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=4bf144ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf144ec",
  null
  
)

export default component.exports